$(document).ready(function (event) {

  var players = []
  var playingWithSound = 0

  var videoEmbeds = $('.video')
  // loop through all players and store in array
  for (var i = 0; i < videoEmbeds.length; i++) {
    var dataType = videoEmbeds[i].getAttribute('data-type')
    var video = videoEmbeds[i].querySelector('iframe')
    var player = new Vimeo.Player(video)
    players.push(player)
  }

  $('.video__audio-btn').on('click', function () {
    if ($(this).hasClass('unmuted')) {
      $(this).removeClass('unmuted')
      $(this).find('span').text('Sound On')
    }
    else {
      $(this).addClass('unmuted')
      $(this).find('span').text('Sound Off')
    }
    var id = parseInt($(this).attr('data-id'))
    for (var i = 0; i < players.length; i++) {
      var dataId = parseInt(players[i].element.getAttribute('data-id'))
      if (id === dataId) {
        if (playingWithSound === dataId) {
          players[i].setVolume(0)
          playingWithSound = 0
        }
        else {
          for (var x = 0; x < players.length; x++) {
            if (players[x] === players[i]) {
              // set volume of matched video
              players[x].setVolume(1)
              // play video from beginning
              players[x].setCurrentTime(0)
            }
            else {
              // turn volume off for all other videos
              players[x].setVolume(0)
            }
          }
          // set current playing id
          playingWithSound = dataId
        }
      }
    }
  })
  
});